module.exports = __webpack_public_path__ + "static/media/Naske.0ad0e5fd.m4a";